<template>
  <div class="pageShow " v-if="tabShow" :class="{ 'pg2': pageBg }">

    <div style="display:block; ">
      <li v-for="item in columnInfo" :key="item.id" class="active">
        <div class="heading" v-if="item.uiType == 8">
          <p>
            <i style="position: relative; top: 5px;margin-right: 5px;">
              <img src="@/assets/titleBlock/heading1.png" alt="">
            </i>
            {{ item.name }}
            <i style="position: relative; top: 5px;margin-left: 5px;">
              <img src="@/assets/titleBlock/heading2.png" alt="">
            </i>
          </p>
          <!-- <TitleTag> <span slot="title" style="font-size:14px;font-weight:800;">{{item.name}} </span></TitleTag> -->
        </div>
        <!-- <div class="table-list" :class="{ 'active': ColPage,'active2': !ColPage,}" v-else> -->
        <div class="table-list active2" v-else>
          <div class="table-list">
            <span class="list-key" :title="item.name">{{ item.name }}</span>
            <span style="display: inline-block;margin: 0 6px;">:</span>
            <span class="list-val" :data-attr="noData" :title="item.val">{{ item.val }}</span>
          </div>
        </div>
      </li>
    </div>

  </div>
</template>

<script>
import TitleTag from '@/components/titleTag'

export default {
  data() {
    return {
      pageBg: false,

      tabShow: true,
      pageInfo: {},
      columnInfo: [],
      column: [],
      ColPage: false,
      titlePage: '',
      pageBg: false,
      searchMf: '',
      pageOrder: [this.$t("message.title.pageOne"), this.$t("message.title.pageTwo"), this.$t("message.title.pageThree")],

      pageData: {},
      input_width: {
        width: "50%",
      },

      noData: this.$t("message.tips.noData"),

    }
  },
  components: {
    TitleTag,
  },
  props: ["page", 'pageIndex', 'reset'],
  methods: {
    getColumn() {
      if (this.page.column.ids.length == 0) {
        this.columnInfo = [];
        this.tabShow = false;
        return
      }
      // console.log(2222,this.page);
      let arr = this.getNewData(this.page.column);
      // console.log(9998877,arr);
      let val = this.deepCopy(this.page.val.cells);
      // console.log(val);
      arr.map((i, e) => {
        i.val = JSON.stringify(val[e].val) == "{}" ? '' : val[e].val
        if (i.uiType == 4 && i.listType == 2) {
          const ids = !val[e].ids ? [] : val[e].ids.split(';')
          i.val = ids.map(j => this.getParentNameList(i.listEntrie, j).join('/')).join(',')
        }
        if (i.uiType == 3 && i.listType == 2) {
          i.val = !val[e].val ? '' : this.getParentNameList(i.listEntrie, val[e].id).join('/');
        }
        if (i.uiType == 6) {
          // i.val = '￥ ' + parseInt(i.val).toFixed(2) 
          i.val = i.val.split('T')[0]
        }
        if (i.uiType == 10) {
          // i.val = !i.val? '': '￥'  + parseInt(i.val).toFixed(2)
          i.val = !i.val ? '' : '￥' + parseFloat(i.val).toFixed(2)
        }
      })
      // console.log(arr);
      // const n = arr.find(i => i.id ==1051003)
      // console.log(n);
      // if (n) {
      //   n.val = this.timeDiff((arr.find(i => i.id ==1051001).val:0),(arr.find(i => i.id ==1051002).val))
      // }
      this.columnInfo = arr
    },


  },
  created() {
    // //console.log(this.pageId);
    this.getColumn();
  },
  mounted() {
    this.titlePage = this.pageOrder[this.pageIndex],
      this.pageBg = !!(this.pageIndex == 1);
  },
  watch: {
    reset() {
      this.getColumn();
    },
    page: {
      handler() {
        this.getColumn()
      },
      deep: true
    }

  }
}
</script>


<style>
li {
  list-style: none;
}

.moneyUi .el-input-group__append {
  width: 30% !important;
}
</style>

<style scoped>
.pageShow {
  width: 100%;
  margin: 10px 0 10px 0px;
  padding: 10px 0 0 15px;
  position: relative;
  display: block;
  overflow: hidden;
}

.active {
  width: 96%;
  display: block;
}

.active2 {
  width: 35%;
  float: left;
}


.items li {
  list-style: none;
}


.heading {
  width: 100%;
  float: left;
  margin: 10px 0 10px 60px;
}

.heading-edit {
  width: 100% !important;
  margin: 0 0 18px 40px;
}

.heading p {
  font-size: 16px;
  font-weight: 600;
  margin: 0;
}

.title-heading {
  width: 100%;
  float: left;
  margin: 0 0 25px 0px;
}

.title-heading p {
  font-size: 18px;
  font-weight: bold;
  margin: 0;
}

ul {
  margin: 0;
}

.line01 {
  border-bottom: 1px solid #cecece;
  padding: 10px 0;
}

div {
  font-size: 12px;
}

.table-list {
  height: 24px;
  overflow: hidden;
  margin-top: 3px;
  margin-right: 20px;
  margin-left: 20px;
  /* width: 48%; */
}

/* .table-list li {
    overflow: hidden;
  } */

.table-list .list-key {
  display: inline-block;
  width: 38%;
  text-align: right;
  font-size: 14px;
  /* height: 14px; */
  overflow-x: visible;
  /* overflow-y: visible; */
  white-space: nowrap;
  /*规定文本不进行换行*/
  text-overflow: ellipsis;
}

.table-list .list-val {
  display: inline-block;
  width: 52%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 18px;
  font-size: 14px;
  position: relative;
  top: 3px;
}

.list-val:empty::before {
  /* content: '\6682\65e0'; */
  content: attr(data-attr);
  color: #C0C4CC;
}

.table-list .list-key-1 {
  display: inline-block;
  width: 18.5%;
  text-align: right;
  font-size: 14px;
  color: #000;
}

.pg2 {
  padding: 0px 15px 10px 15px;
  overflow: hidden;
  background: #f3f7fa;
  background-image: url(~@/assets/titleBlock/page2.png);
  background-repeat: no-repeat;
  background-position: bottom right;
}
</style>
